import { Navigate, useLocation } from "react-router-dom"
import { RoleName } from "../features/auth/types"
import { useAuthState } from "../features/auth/hooks/useAuthState"

type ProtectedRouteProps = {
  allowedRoles: RoleName[]
  children: React.ReactNode
}

export const ProtectedRoute = ({
  allowedRoles,
  children,
}: ProtectedRouteProps) => {
  const { user } = useAuthState()
  const location = useLocation()

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  if (
    !user.roles?.some((role) => allowedRoles.includes(role.roleId)) &&
    !allowedRoles.includes(user.role)
  ) {
    return <Navigate to="/dashboard" replace />
  }

  return <>{children}</>
}
